/**
 * Central permission helpers — keeps role logic out of components.
 */

export const isSuperAdmin = (user) => user?.role === 'SUPER_ADMIN';
export const isAdmin      = (user) => user?.role === 'ADMIN' || isSuperAdmin(user);
export const isManager    = (user) => user?.role === 'MANAGER' || isAdmin(user);
export const isStaff      = (user) => user?.role === 'STAFF' || isManager(user);
export const isSecurityOut = (user) => user?.role === 'SECURITY_OUT';
export const isSecurityIn  = (user) => user?.role === 'SECURITY_IN';
export const isMerchantExporter = (user) => user?.role === 'MERCHANT_EXPORTER';

export const canCreateGatePass = (user) =>
  ['SUPER_ADMIN', 'ADMIN', 'MANAGER', 'STAFF'].includes(user?.role);

export const canApproveGatePass = (user) =>
  ['SUPER_ADMIN', 'ADMIN', 'MANAGER'].includes(user?.role);

export const canCancelGatePass = (user) =>
  ['SUPER_ADMIN', 'ADMIN'].includes(user?.role);

export const canAcknowledgeDispatch = (user) =>
  ['SUPER_ADMIN', 'ADMIN', 'SECURITY_OUT'].includes(user?.role);

export const canAcknowledgeReceipt = (user) =>
  ['SUPER_ADMIN', 'ADMIN', 'SECURITY_IN'].includes(user?.role);

export const canAccessMasters = (user) => isSuperAdmin(user);

export const canAccessFileManager = (user) =>
  ['SUPER_ADMIN', 'ADMIN'].includes(user?.role);

export const canAccessReports = (user) =>
  ['SUPER_ADMIN', 'ADMIN', 'MANAGER'].includes(user?.role);

export const canViewAllLocations = (user) =>
  ['SUPER_ADMIN', 'ADMIN'].includes(user?.role);

/**
 * Check if a user has access to a specific location.
 */
export const hasLocationAccess = (user, locationId) => {
  if (isSuperAdmin(user)) return true;
  return user?.locations?.some((ul) => ul.locationId === locationId || ul.location?.id === locationId);
};
